export default function Header({ count }) {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#F5F1E6]/85 border-b border-[#E0D8C6]"
    >
      <div className="px-6 sm:px-10 lg:px-16 h-16 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="text-[13px] font-medium tracking-[0.3em] uppercase text-[#3C3527]"
          data-testid="brand-link"
        >
          Prime Collective
        </button>
        <nav className="flex items-center gap-5 sm:gap-8">
          <span
            className="hidden md:inline text-[10px] tracking-[0.25em] uppercase text-[#6E6553]"
            data-testid="header-frame-count"
          >
            {count} frames
          </span>
          <button
            onClick={() => go("gallery")}
            data-testid="header-gallery-link"
            className="text-xs text-[#3C3527]/75 hover:text-[#3C3527] transition-colors duration-300"
          >
            Gallery
          </button>
          <button
            onClick={() => go("upload")}
            data-testid="header-add-photos-btn"
            className="text-xs text-[#3C3527]/75 hover:text-[#75332D] transition-colors duration-300"
          >
            Add photos
          </button>
        </nav>
      </div>
    </header>
  );
}
